<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-menu-button autoHide="false"></ion-menu-button>
      <ion-back-button defaultHref="/call/dashboard" text="" icon="chevron-back"></ion-back-button>
    </ion-buttons>
    <ion-title>{{title}}</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content>
  <form class="ion-padding form" [formGroup]="form" (submit)="requestTrip()">
    <ion-img src="assets/user.png" class="ico" />
    <h3 style="vertical-align: middle;">
      Hello.
    </h3>
    <h3>
      Enter your name and phone number below to validate your access.
    </h3>
    <ion-item>
      <ion-label position="floating">Client Name</ion-label>
      <ion-input type="text" formControlName="nomeCliente"></ion-input>
    </ion-item>
    <ion-item class="ion-margin-bottom">
      <ion-label position="floating">Cell Phone</ion-label>
      <ion-input type="text" formControlName="celular"></ion-input>
    </ion-item>
    <button class="ion-margin-top button-bigger" [disabled]="form.invalid">Validate Link</button>
  </form>
</ion-content>